import React from 'react';
import SafeIcon from '../../../common/SafeIcon';
import { FiCalendar, FiBell, FiX } from 'react-icons/fi';

const StepSchedule = ({ form, update }) => {
  const addReminder = () => {
    if (form.reminderDays.length < 5) update({ reminderDays: [...form.reminderDays, 1] });
  };
  const removeReminder = (i) => update({ reminderDays: form.reminderDays.filter((_, idx) => idx !== i) });
  const updateReminder = (i, v) => {
    const days = [...form.reminderDays];
    days[i] = Number(v);
    update({ reminderDays: days });
  };

  return (
    <div className="space-y-5">
      <div className="grid grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-semibold text-slate-700 mb-1.5">
            <SafeIcon icon={FiCalendar} className="inline mr-1.5 text-blue-500" />Start Date <span className="text-red-500">*</span>
          </label>
          <input type="date" value={form.startDate} onChange={e => update({ startDate: e.target.value })}
            className="w-full px-3 py-2.5 border border-slate-200 rounded-lg text-sm focus:outline-none focus:border-blue-500 bg-slate-50" />
        </div>
        <div>
          <label className="block text-sm font-semibold text-slate-700 mb-1.5">
            <SafeIcon icon={FiCalendar} className="inline mr-1.5 text-red-500" />Due Date <span className="text-red-500">*</span>
          </label>
          <input type="date" value={form.endDate} onChange={e => update({ endDate: e.target.value })}
            min={form.startDate}
            className="w-full px-3 py-2.5 border border-slate-200 rounded-lg text-sm focus:outline-none focus:border-blue-500 bg-slate-50" />
        </div>
      </div>

      <div className="bg-slate-50 rounded-xl border border-slate-200 p-4">
        <div className="flex items-center justify-between mb-3">
          <div className="flex items-center gap-2">
            <SafeIcon icon={FiBell} className="text-orange-500" />
            <p className="text-sm font-semibold text-slate-700">Automated Reminders</p>
          </div>
          <label className="flex items-center gap-2 cursor-pointer">
            <span className="text-xs text-slate-500">{form.reminderEnabled ? 'On' : 'Off'}</span>
            <button type="button" onClick={() => update({ reminderEnabled: !form.reminderEnabled })}
              className={`relative w-10 h-5 rounded-full transition-colors ${form.reminderEnabled ? 'bg-blue-600' : 'bg-slate-300'}`}>
              <span className={`absolute top-0.5 left-0.5 w-4 h-4 bg-white rounded-full shadow transition-transform ${form.reminderEnabled ? 'translate-x-5' : ''}`} />
            </button>
          </label>
        </div>

        {form.reminderEnabled && (
          <div className="space-y-2">
            <p className="text-xs text-slate-500 mb-2">Send reminders X days before due date:</p>
            {form.reminderDays.map((d, i) => (
              <div key={i} className="flex items-center gap-2">
                <input type="number" value={d} min={1} max={60} onChange={e => updateReminder(i, e.target.value)}
                  className="w-20 px-3 py-1.5 border border-slate-200 rounded-lg text-sm focus:outline-none focus:border-blue-500 text-center" />
                <span className="text-xs text-slate-500">days before due date</span>
                <button onClick={() => removeReminder(i)} className="ml-auto text-slate-300 hover:text-red-400 transition-colors">
                  <SafeIcon icon={FiX} />
                </button>
              </div>
            ))}
            {form.reminderDays.length < 5 && (
              <button onClick={addReminder} className="text-xs text-blue-600 hover:text-blue-800 font-medium mt-1">+ Add reminder</button>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default StepSchedule;